import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Injector,
  Renderer2,
  ViewChild
} from "@angular/core";
import {applyArrowStyles, calculatePosition, IBox} from "../../position";
import {Observable} from "rxjs";

export type NHintPlacement = "top" | "left" | "right" | "bottom";

@Component({
  selector: "n-hint",
  styleUrls: [
    "./n-hint.css"
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="container">
      <div class="text-container">
        <span class="title">{{title$ | async}}</span>
        <span *ngIf="subtitle$ | async"
              class="subtitle">{{subtitle$ | async}}</span>
      </div>
      <div *ngIf="sideNote$ | async"
            class="side-note">{{sideNote$ | async}}</div>
    </div>
    <span #arrow class="arrow"></span>`
})
export class NHintComponent implements AfterViewInit {

  title$: Observable<string>;
  subtitle$: Observable<string>;
  sideNote$: Observable<string>;

  @ViewChild("arrow", {static: true})
  arrow: ElementRef;

  private targetElement: ElementRef;
  private placement: NHintPlacement;

  constructor(private el: ElementRef,
              private injector: Injector,
              private renderer: Renderer2) {

    const options = this.injector.get(NHintOptions);

    this.title$ = options.title$;
    this.subtitle$ = options.subtitle$;
    this.sideNote$ = options.sideNote$;
    this.placement = options.placement;
    this.targetElement = options.target;

    renderer.setAttribute(el.nativeElement, "role", "tooltip");
  }

  ngAfterViewInit() {
    const targetRect = this.targetElement.nativeElement.getBoundingClientRect();

    const windowContainer: IBox = {
      width: (document.body.offsetWidth || document.body.clientWidth),
      height: window.innerHeight
    };

    let arrowSize: IBox;
    switch (this.placement) {
      case "left":
      case "right":
        arrowSize = {width: 5, height: 10};
        break;
      case "top":
      case "bottom":
        arrowSize = {width: 10, height: 5};
        break;
    }

    const position = calculatePosition(this.placement,
      targetRect,
      {height: this.el.nativeElement.clientHeight, width: this.el.nativeElement.clientWidth},
      windowContainer, undefined, arrowSize
    );

    const popoverY = position.top + (window.pageYOffset || document.documentElement.scrollTop);

    this.renderer.setStyle(this.el.nativeElement, "left", position.left + "px");
    this.renderer.setStyle(this.el.nativeElement, "top", popoverY + "px");

    // position arrow

    this.renderer.addClass(this.arrow.nativeElement, `_${position.arrowPos.arrowPlacement}`);
    applyArrowStyles(this.renderer, this.arrow, position.arrowPos);
  }

}

export class NHintOptions {

  readonly title$: Observable<string>;
  readonly subtitle$: Observable<string>;
  readonly sideNote$: Observable<string>;
  readonly placement: NHintPlacement;
  readonly target: ElementRef;

  constructor(title: Observable<string>,
              subtitle: Observable<string>,
              sideNote: Observable<string>,
              placement: NHintPlacement,
              target: ElementRef) {
    this.title$ = title;
    this.subtitle$ = subtitle;
    this.sideNote$ = sideNote;
    this.placement = placement;
    this.target = target;
  }

}
